import Typography from '@precis-digital/kurama/Typography'
import { styled } from '@precis-digital/kurama/utils'

export const StyledTypographyAnnotation = styled(Typography)<{ $hasTooltip?: boolean }>(
  ({ theme, $hasTooltip: hasTooltip }) => ({
    color: theme.tokens.foreground.main.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...(hasTooltip === true && {
      color: theme.tokens.foreground.main.link,
      cursor: 'pointer'
    })
  })
)
